import React from "react";
import { colors } from "src/config/colors";
import { IconButton, Stack } from "@mui/material";
import { CrossClose } from "src/assets/icons/index";
import ProductItem from "src/components/ReservationProduct/components/ProductItem";
import Box from "@mui/material/Box";
import { ProductOffersItemPharmaciesSchema2 } from "src/models/productPharmacies/getProductPharmacies";
import { ProductCart } from "src/redux/slice/basketSlice";
import { ReservationProductParams } from "src/components/ReservationProduct/ReservationProduct";
import {
  EnumMetrikActions,
  sendCustomYandexMetrik,
} from "src/config/analytics/sendCustomYandexMetrik";

interface MapReservationPanelProps {
  setOpenReservationPanel: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenReservationPanel: boolean;
  dataSelectedMapOffers?: ProductOffersItemPharmaciesSchema2[];
  setOpenDetailModal: React.Dispatch<React.SetStateAction<boolean>>;
  imgSource: string;
  toBookClick: (
    arg0: ReservationProductParams,
    arg1: Omit<ProductCart, "slug">
  ) => void;
}

const MapReservationPanel: React.FC<MapReservationPanelProps> = ({
  setOpenReservationPanel,
  isOpenReservationPanel,
  dataSelectedMapOffers,
  setOpenDetailModal,
  imgSource,
  toBookClick,
}) => {
  return (
    <Box
      sx={{
        display: isOpenReservationPanel ? { xs: "none", md: "flex" } : "none",
        position: "absolute",
        top: 40,
        left: 60,
        backgroundColor: colors.white,
        boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.5)",
        maxWidth: "600px",
      }}
    >
      <IconButton
        onClick={() => setOpenReservationPanel(false)}
        sx={{
          position: "absolute",
          top: "5px",
          right: "10px",
          zIndex: 1301,
        }}
      >
        <CrossClose color="#11193E" />
      </IconButton>
      <Stack spacing={1}>
        {dataSelectedMapOffers?.map((value, index) => (
          <ProductItem
            allowCart={value.offer.allowCart}
            exclusivePrice={value.offer.exclusivePrice}
            futureBooking={value.offer.futureBooking}
            isMapPriorOffer={value.offer.isMapPriorOffer}
            isListPriorOffer={value.offer.isListPriorOffer}
            productName={value.pharmacy_product_name}
            price={value.offer.price}
            pharmacyAddress={value.pharm.address}
            pharmacyName={value.pharm.name}
            key={value.offer.offerProductId + index}
            setOpenDetailModal={setOpenDetailModal}
            imgSrc={imgSource}
            toBookClick={() => {
              sendCustomYandexMetrik(EnumMetrikActions.bookingByMap);
              toBookClick(
                {
                  offerProductId: value.offer.offerProductId,
                  offerCompanyId: value.offer.companyId,
                },
                {
                  name: value.pharmacy_product_name,
                  productId: value.offer.offerProductId,
                  address: value.pharm.address,
                  imgSource,
                  pharmacyName: value.offer.companyName,
                  pharmacyPhone: value.pharm.salePhone,
                  pharmacySchedule: value.pharm.saleSchedule,
                  cartInfo: value.pharm.cartInfo,
                  bookingInfo: value.pharm.bookingInfo,
                  minPriceForBuy: value.pharm.minPriceForBuy,
                  fullName: value.pharmacy_product_name || "",
                  mnn: "",
                  price: value.offer.price,
                  brandName: value.pharm.brand_name,
                  counter: 1,
                  quantity: value.offer.quantity,
                }
              );
              setOpenReservationPanel(false);
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default MapReservationPanel;
